import type { MoveAction, PaddleState, WorldState } from './world';

export const NPC_PLAYER_ID = 'npc';

const DEAD_ZONE = 0.2;

export function npcMovement(world: WorldState, paddle: PaddleState): MoveAction {
  const offset = world.ball.x - paddle.x;
  if (Math.abs(offset) <= DEAD_ZONE) return { x: 0 };
  return { x: Math.sign(offset) };
}
